<template>
    <BaseModal ref="baseModalRef" v-bind="childProps">
        <template v-slot:body>
            <div class="search-wrap">
                <div class="row">
                    <div class="col-md-6">
                        <div class="mb-3">
                        <ElLabel name="회계년도"/>
                        <div class="d-flex justify-content-between">
                            <DatePicker v-model="state.searchParams.fs_year" :format="state.format" :year-picker="true" />
                          </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="mb-3">
                            <ElLabel name="일시"/>
                            <div class="d-flex justify-content-between">
                                <DatePicker :select-date="state.searchParams.start_dt" @return="r => state.searchParams.start_dt = r" />&nbsp;~&nbsp;
                                <DatePicker :select-date="state.searchParams.end_dt" @return="r => state.searchParams.end_dt = r"/>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="search-detail-wrap"></div> -->
        
                <div class="text-end py-2">
                    <ElButton type="search" @buttonClick="searchEvent()">검색</ElButton>
                </div>
                <div class="table-responsive table-list">

                    <DataTable  
                        v-model:selection="state.selectedRow" 
                        :value="state.gridRowData"   
                        selectionMode="single"
                        dataKey="ev_seq"
                        paginator 
                        :rows="20" 
                        :rowsPerPageOptions="[10, 20, 50, 100,200]" 
                        @row-dblclick="rowDbClick"
                    >
                        <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
                        <Column :class="['elip-div']" v-for="event of state.gridColumn" :key="event" :field="event.field" :header="event.headerName" style="max-width: 120px"></Column>
                    </DataTable>
                </div>
            </div>
        </template>
    </BaseModal>
    
</template>
    
<script setup>
import {reactive,ref,onMounted, onBeforeMount} from 'vue'
import DatePicker from '@/components/common/DatePicker.vue';
import { useRouter } from "vue-router";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import BaseModal from '@/components/common/modal/BaseModal.vue';

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { eventList } from '@/api/event';

const router = useRouter();
const yearsList = ref([]);
const emits = defineEmits(['return'])

const baseModalRef = ref()

onMounted(() => {
  getYearsList();
})

onBeforeMount(async()=> {
  state.searchParams.start_dt = startStr;
  state.searchParams.end_dt = endStr;
  getDataList();
})


const state = reactive({
    gridColumn : [
        { headerName: 'NO' ,           field: "ev_seq",  width:100},
        { headerName: '이벤트 이름' ,   field: "event_nm", },
        { headerName: '일시' ,          field: "fmt_event_dt", },
        { headerName: '장소' ,          field: "event_place", },
        { headerName: '주관사' ,        field: "sponsor", },
        { headerName: '목적' ,          field: "prpss", },
        { headerName: '발표자' ,        field: "prsnt", },
        { headerName: '등록자' ,        field: "reg_user_nm", },
        { headerName: '수정자' ,        field: "upd_user_nm", },
        
    ],
    gridRowData :[],
    selectedRow :[],
    searchParams : {
        fs_year : '',       // 회계년도   
        event_nm : '',      // 이벤트명
        prpss : '',         // 목적
        start_dt : '',    
        end_dt : '',
        page_count : 1,
        unit_count : 100000,
    },
    format:'yyyy'
})

const childProps = ref({
    modalId : 'event',
    modalNm:'이벤트 조회/수정',
    size: 'xl',
    btnList:[
        {name : '선택',classNm : 'modelFooterConfirm', function:selectEvent}
    ]
})

function openModal(){
    baseModalRef.value.openModal()
}

function closeModal(){
    baseModalRef.value.closeModal()
}

function getYearsList(){
    const prevYear   = new Date().getFullYear()-6;   // 2018
    const currYear   = new Date().getFullYear();     // 2024 
    
        for(let i = currYear; i >= prevYear; i--) {
        yearsList.value = [...yearsList.value, i];  ///yearsList.value.push(i); 배열표현법이 신기하다
        
    
        }
     
    state.searchParams.fs_year = yearsList.value[0];
}

// 기간설정 초기화 중 DatePicker에서 한달 후 값으로 입력받아 넣으니 달을 바꿔도 무조건 
// 그 다음달로 초기화 되어 end_dt에 대해서만 적용해 주기 위해 아래 값으로 대체함.
var dt=new Date();
var startStr=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
var endStr=dt.getFullYear()+'-'+(dt.getMonth()+2)+'-'+dt.getDate();



async function getDataList(){

    let url = '/event/eventList'

    let params = {
        fs_year : state.searchParams.fs_year,
        event_nm : state.searchParams.event_nm,
        prpss : state.searchParams.prpss,
        start_dt : state.searchParams.start_dt,
        end_dt : state.searchParams.end_dt
    }

    try {
        setIsLoading(true)
        const res = await eventList(params)
        state.gridRowData = res.rtn;
    } catch (err) {
        alert("조회 중 에러가 발생하였습니다.");
    } finally {
        setIsLoading(false)
    }
    
};




function searchEvent(){
    /* 
    회계년도 및 기간관련 Validation Check
    */        
    if(state.searchParams.start_dt > state.searchParams.end_dt) {
        alert('기간 설정을 확인하세요!') 
        return false
    }
    if (state.searchParams.start_dt) {
        if ((state.searchParams.fs_year != state.searchParams.start_dt.substring(0, 4))) {
        alert('회계년도와 일시 조건이 서로 일치하지 않습니다.')
        return false
        }
    }

    if (state.searchParams.end_dt) {
        if ((state.searchParams.fs_year != state.searchParams.end_dt.substring(0, 4))) {
        alert('회계년도와 일시 조건이 서로 일치하지 않습니다.')
        return false
        }
    }

    getDataList();
}

/*
const pageLink = (seq) =>{
    router.push({ path: 'MSM_SA_004', query: { ev_seq: seq }})
}
*/


function selectEvent(){
    let event = state.selectedRow
    if(event){
        emits('return',event)
        closeModal()
    }else{
        alert('선택된 이벤트가 없습니다.')
    }
}

function rowDbClick(row){
    emits('return',row.data)
    closeModal()
}



defineExpose({
    openModal,
    closeModal
})

</script>